import { renderBrowserTestingCurrentWorkflowAuthoring } from './browser-testing/current-workflow-authoring.js';
import { renderBrowserTestingSections } from './browser-testing/render-sections.js';
import {
  renderBrowserTestingFrontmatter,
  renderBrowserTestingSessionGuide,
} from './browser-testing/shared-session-sections.js';
import { renderBrowserTestingWorkflowDetails } from './browser-testing/shared-workflow-sections.js';

export const browserTestingRenderCurrent = () =>
  renderBrowserTestingSections([
    renderBrowserTestingFrontmatter('1.1.0'),
    renderBrowserTestingSessionGuide(),
    renderBrowserTestingCurrentWorkflowAuthoring(),
    renderBrowserTestingWorkflowDetails(),
  ]);
